module.exports = __webpack_public_path__ + "img/logo_main.23bf5bcd.svg";